export default __webpack_public_path__ + "static/media/ray-fix.7f2314f3.png";